export const CommonValues = {
};


export const UnavailabilityType: any = ['Unavailable', 'Not Reachable', 'Not Well'];
export const AvailiabilityJson: any = [{
    text: 'Monday',
    day: null,
    timing: {
        "slot": [],
        "queue": []
    },
},
{
    text: 'Tuesday',
    day: null,
    timing: {
        "slot": [],
        "queue": []
    },
},
{
    text: 'Wednesday',
    day: null,
    timing: {
        "slot": [],
        "queue": []
    },
},
{
    text: 'Thursday',
    day: null,
    timing: {
        "slot": [],
        "queue": []
    },
},
{
    text: 'Friday',
    day: null,
    timing: {
        "slot": [],
        "queue": []
    },
},
{
    text: 'Saturday',
    day: null,
    timing: {
        "slot": [],
        "queue": []
    },
},
{
    text: 'Sunday',
    day: null,
    timing: {
        "slot": [],
        "queue": []
    },
}];

export const encryptKey="ain44j3hf998unc2nmcm238n34mc12398384mn";
export const plusEncryptKey="999999999s";
export const slashEncryptKey="999999999h";
export const equalEncryptKey="999999999e";

export const LoginLink = 'auth/login';
